/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { KaryaColorTheme } from '../Attributes';
import { colorsV2, KaryaColor } from '../Colors';

const generateColorMapping = (colorObject: Record<string, string>): Record<string, string> => {
  const result: Record<string, string> = {};
  Object.keys(colorObject).forEach((key) => {
    const value = KaryaColor[key as keyof typeof KaryaColor];
    if (typeof value === 'string') {
      result[key] = value;
    }
  });

  return result;
};

const mappedColors = generateColorMapping(colorsV2);

export const colors: KaryaColorTheme = {
  white: KaryaColor['white'],
  black: KaryaColor['black'],
  stockGray: KaryaColor['stockGray'],
  lightGray: KaryaColor['lightGray'],
  almostWhite: KaryaColor['almostWhite'],
  dirtyWhite: KaryaColor['dirtyWhite'],
  primary: KaryaColor['impactGreen'],
  primaryDark: KaryaColor['deepSea'],
  primaryBackground: KaryaColor['lightGreen'],
  impactGreen: KaryaColor['impactGreen'],
  deepSea: KaryaColor['deepSea'],
  crimsonRed: KaryaColor['darkCrimson'],
  techBlue: KaryaColor['techBlue'],
  skyBlue: KaryaColor['skyBlue'],
  ...mappedColors,
};
